/**
 * Returns an object with properties that indicate whether a given amenity is included based
 * on the text of the notice string. Notice string must match exactly.
 * @param notice
 * @returns {{seatSelection: boolean, carryOnBag: boolean}}
 */
export default function index(notice) {
  const amenities = {
    seatSelection: false,
    carryOnBag: false,
  }

  if (notice === 'Basic Economy. Carryon Bag Included. No advance seat assignments') {
    amenities.carryOnBag = true
  } else if (
    notice === 'Carryon and seat selection included' ||
    notice === 'Carryon Bag and advance seat assignments are included.'
  ) {
    amenities.seatSelection = true
    amenities.carryOnBag = true
  } else if (
    notice === 'Basic Economy. Carryon Bag Included. Seat selection available for a fee after ticket purchase'
  ) {
    amenities.seatSelection = false
    amenities.carryOnBag = true
  }

  return amenities
}
